import React, { MutableRefObject } from 'react';
import { Message } from './types';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';
import { ChatArea as ChatAreaWrapper } from './styles';

interface ChatAreaProps {
  messages: Message[];
  isLoading: boolean;
  isDarkMode: boolean;
  onSendMessage: (message: string) => void;
  audioCacheRef: MutableRefObject<Map<string, string>>;
  autoPlayTargetId: string | null;
  onAutoPlayDone: () => void;
}

const ChatArea: React.FC<ChatAreaProps> = ({
  messages,
  isLoading,
  isDarkMode,
  onSendMessage,
  audioCacheRef,
  autoPlayTargetId,
  onAutoPlayDone,
}) => {
  return (
    <ChatAreaWrapper>
      <ChatMessages
        messages={messages}
        isLoading={isLoading}
        isDarkMode={isDarkMode}
        audioCacheRef={audioCacheRef}
        autoPlayTargetId={autoPlayTargetId}
        onAutoPlayDone={onAutoPlayDone}
      />
      <ChatInput
        onSend={onSendMessage}
        disabled={isLoading}
        isDarkMode={isDarkMode}
      />
    </ChatAreaWrapper>
  );
};

export default ChatArea;
